// ── BREDA Installation Coupon — auto-add / auto-remove ───────────────────────
// window.BREDA_COUPON_ID is set by the product page Liquid block.
// On every cart:update: if real products are present and coupon is missing → add it.
// If cart has no real products but coupon is present → remove it.

(function () {
  var running = false;

  async function syncCoupon() {
    var couponId = window.BREDA_COUPON_ID;
    if (!couponId || running) return;
    running = true;

    try {
      var cart = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then(function (r) { return r.json(); });

      var couponInCart  = cart.items.some(function (i) { return i.variant_id === couponId; });
      var hasRealItems  = cart.items.some(function (i) { return i.variant_id !== couponId; });

      if (hasRealItems && !couponInCart) {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: couponId, quantity: 1 }] })
        });
        if (res.ok && typeof bredarRefreshCartDrawer === 'function') {
          await bredarRefreshCartDrawer();
        }
      } else if (!hasRealItems && couponInCart) {
        var res2 = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: couponId, quantity: 0 })
        });
        if (res2.ok && typeof bredarRefreshCartDrawer === 'function') {
          await bredarRefreshCartDrawer();
        }
      }
    } catch (_) {
      // Non-critical — fail silently.
    } finally {
      running = false;
    }
  }

  document.addEventListener('cart:update', function (event) {
    // Skip update events that don't involve real cart mutations
    var detail = event.detail;
    if (detail && detail.data && detail.data.didError) return;
    syncCoupon();
  });
})();
